import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export const initSwiper = ( element: HTMLElement ) => {
    const configData = element.getAttribute( 'data-swiper-config' );
    if ( ! configData ) return;
    
    const config = JSON.parse( configData );
    const swiperEl = element.querySelector( '.swiper' ) as HTMLElement;
    if ( ! swiperEl ) return;

    // Check if swiper is already initialized
    if ( ( swiperEl as any ).swiper ) {
        return;
    }

    const updateSlidesPerView = () => {
        const containerWidth = swiperEl.offsetWidth;
        if ( containerWidth === 0 ) return config.slidesToShow || 1;

        let minWidthPx = config.minWidth || 300;
        
        if ( config.minWidthUnit === 'rem' ) {
            const rootFontSize = parseFloat( getComputedStyle( document.documentElement ).fontSize ) || 16;
            minWidthPx = minWidthPx * rootFontSize;
        }
        
        const canFit = Math.max( 1, Math.floor( containerWidth / minWidthPx ) );
        const slidesPerView = Math.min( config.slidesToShow || 3, canFit );
        
        return slidesPerView;
    };

    const swiper = new Swiper( swiperEl, {
        modules: [ Navigation, Pagination ],
        slidesPerView: updateSlidesPerView(),
        spaceBetween: 20,
        loop: !!config.loop,
        observer: true,
        observeParents: true,
        navigation: config.showArrows ? {
            nextEl: element.querySelector( '.swiper-button-next' ) as HTMLElement,
            prevEl: element.querySelector( '.swiper-button-prev' ) as HTMLElement,
        } : false,
        pagination: config.showDots ? {
            el: element.querySelector( '.swiper-pagination' ) as HTMLElement,
            clickable: true,
        } : false,
        on: {
            resize: ( s ) => {
                s.params.slidesPerView = updateSlidesPerView();
                s.update();
            }
        }
    } );

    // Handle orientationchange or other window events that might not trigger resize correctly on all devices.
    window.addEventListener( 'orientationchange', () => {
        setTimeout( () => {
            swiper.params.slidesPerView = updateSlidesPerView();
            swiper.update();
        }, 100 );
    } );
};
